import { root, id } from './team-viewer';

export const teamViewer = {
  ...root,
  id,
};
